module.exports = __webpack_public_path__ + "static/media/caret_down_filled.be865d83.svg";